// Generated by @uiux/cli
// Paths are relative to root app directory where index.html is served.
export const svgAssets: any = {
  ICON: 'assets/svg/icon-v0.svg'
};
